import React from "react";

export default function about() {
  return (
    <div>
      <main className="main pages">
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a rel="nofollow">
                <i className="fi-rs-home mr-5" />
                Home
              </a>
              <span> About us</span>
            </div>
          </div>
        </div>
        <div className="page-content pt-50">
          <div className="container">
            <div className="row">
              <div className="col-xl-10 col-lg-12 m-auto">
                <section className="row align-items-center mb-50">
                  <div className="col-lg-6">
                    <img
                      src="/../../assets/images/mallsaylo4.jpg"
                      alt=""
                      className="border-radius-15 mb-md-3 mb-lg-0 mb-sm-4"
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="pl-25">
                      <h2 className="mb-30">Welcome to Mall Say Lo</h2>
                      <p className="mb-25">
                        We are excited to talk about the development of a
                        cutting-edge, real-time online shopping mall platform
                        through our unique website. Our platform showcases
                        renowned shopping malls and premium branded merchandise.
                        In today's online shopping era, customers encounter
                        several troubles that are bad for their experience.
                        These challenges include issues related to trust,
                        product visualization, pricing, sustainability, and
                        convenience, it is evident that there is vast room for
                        improvement. To bridge this gap, we have created a
                        user-friendly platform that allows users to compare
                        product prices from different malls within seconds.
                      </p>
                      <p className="mb-50">
                        We've incorporated search, filtering options, product
                        ranking based on user feedback, personalized
                        recommendations, and secure an, and customer support
                        services to enhance the shopping experience. Our online
                        shopping mall offers a variety of products, including
                        clothing, electronics, furniture, groceries, and more,
                        sourced from various retailers and vendors. Moreover, we
                        are committed to reducing environmental pollution,
                        traffic congestion, and parking issues. With 'Mall Sy
                        Lo,' we deliver products to your doorstep, contributing
                        to a cleaner and greener environment.
                      </p>
                      {/* <div className="carausel-3-columns-cover position-relative">
                        <div id="carausel-3-columns-arrows" />
                        <div
                          className="carausel-3-columns"
                          id="carausel-3-columns"
                        >
                          <img
                            src="/../../assets/images/mallsaylo.jpg"
                            alt=""
                          />
                          <img
                            src="/../../assets/images/mallsaylo1.jpg"
                            alt=""
                          />
                          <img
                            src="/../../assets/images/mallsaylo2.jpg"
                            alt=""
                          />
                          <img
                            src="/../../assets/images/mallsaylo3.jpg"
                            alt=""
                          />
                        </div>
                      </div> */}
                    </div>
                  </div>
                </section>
                <section className="text-center mb-50">
                  <h2 className="title style-3 mb-40">What We Provide?</h2>
                  <div className="row">
                    <div className="col-lg-4 col-md-6 mb-24">
                      <div className="featured-card">
                        <img
                          src="../../assets/imgs/theme/icons/icon-11.png"
                          alt=""
                        />
                        <h4>Best Prices &amp; Offers</h4>
                        <p>
                          To assist users in finding the best offers and saving
                          money, the platform provides real-time price
                          comparisons, discount alerts, and coupons.
                        </p>
                        <a>Read more</a>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-24">
                      <div className="featured-card">
                        <img
                          src="../../assets/imgs/theme/icons/icon-22.png"
                          alt=""
                        />
                        <h4>Trust and Security</h4>
                        <p>
                          By presenting verified merchants and goods and
                          providing open user reviews and ratings, the platform
                          guarantees trust and security.
                        </p>
                        <a>Read more</a>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-24">
                      <div className="featured-card">
                        <img
                          src="../../assets/imgs/theme/icons/icon-33.png"
                          alt=""
                        />
                        <h4>Sustainability</h4>
                        <p>
                          "Mall Sy Lo" promotes environmentally friendly
                          shopping practices and lessens their negative effects
                          on the environment by offering eco-friendly products
                          and green delivery options.
                        </p>
                        <a>Read more</a>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-24">
                      <div className="featured-card">
                        <img
                          src="../../assets/imgs/theme/icons/icon-44.png"
                          alt=""
                        />
                        <h4>Easy Returns</h4>
                        <p>
                          "Mall Sy Lo" refers to a customer-friendly return
                          policy that allows shoppers to return products they
                          purchased online with minimal hassle
                        </p>
                        <a>Read more</a>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-24">
                      <div className="featured-card">
                        <img
                          src="../../assets/imgs/theme/icons/icon-55.png"
                          alt=""
                        />
                        <h4>100% Satisfaction</h4>
                        <p>
                          "100% Satisfaction" and guarantees that customers are
                          completely happy with their purchase, offering full
                          refunds, exchanges, or support if they're not
                          satisfied.
                        </p>
                        <a>Read more</a>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-24">
                      <div className="featured-card">
                        <img
                          src="../../assets/imgs/theme/icons/icon-66.png"
                          alt=""
                        />
                        <h4>Great Daily Deal</h4>
                        <p>
                          "Great Daily Deal" in eCommerce offers a limited-time
                          discount on select products each day, encouraging
                          quick purchases and driving traffic to the site.
                        </p>
                        <a>Read more</a>
                      </div>
                    </div>
                  </div>
                </section>
                <section className="row align-items-center mb-50">
                  {/* <div className="row mb-50 align-items-center">
                    <div className="col-lg-7 pr-30">
                      <img
                        src="../../assets/images/mallsayloVeg.jpg"
                        alt=""
                        className="mb-md-3 mb-lg-0 mb-sm-4"
                      />
                    </div>
                    <div className="col-lg-5">
                      <h4 className="mb-20 text-muted">Our performance</h4>
                      <h1 className="heading-1 mb-40">
                        Your Partner for e-commerce grocery solution
                      </h1>
                      <p className="mb-30">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the leap into
                        electronic typesetting, remaining essentially unchanged.
                      </p>
                      <p>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the leap into
                        electronic typesetting, remaining essentially unchanged.
                      </p>
                    </div>
                  </div> */}
                  <div className="row">
                    <div className="col-lg-4 pr-30 mb-md-5 mb-lg-0 mb-sm-5">
                      <h3 className="mb-30">Who we are</h3>
                      <p>
                        We are an innovative online shopping platform, "Mall Sy
                        Lo," dedicated to enhancing the shopping experience by
                        offering real-time comparisons, personalized
                        recommendations, and eco-friendly delivery solutions.
                      </p>
                    </div>
                    <div className="col-lg-4 pr-30 mb-md-5 mb-lg-0 mb-sm-5">
                      <h3 className="mb-30">Our history</h3>
                      <p>
                        Founded with a vision to revolutionize online shopping,
                        we developed "Mall Sy Lo" to address the challenges
                        faced by modern consumers. Over the years, we've grown
                        into a trusted platform that seamlessly connects users
                        with top-tier malls and brands.
                      </p>
                    </div>
                    <div className="col-lg-4">
                      <h3 className="mb-30">Our mission</h3>
                      <p>
                        Our mission is to revolutionize online shopping by
                        providing a seamless, user-friendly platform that offers
                        real-time price comparisons and personalized
                        recommendations while promoting sustainability through
                        eco-friendly delivery practices.
                      </p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <section className="container mb-50 d-none d-md-block">
            <div className="row about-count">
              <div className="col-lg-1-5 col-md-6 text-center mb-lg-0 mb-md-5">
                <h1 className="heading-1">
                  <span className="count">1</span>+
                </h1>
                <h4>Glorious years</h4>
              </div>
              <div className="col-lg-1-5 col-md-6 text-center">
                <h1 className="heading-1">
                  <span className="count">36</span>+
                </h1>
                <h4>Happy Vendors</h4>
              </div>
              <div className="col-lg-1-5 col-md-6 text-center">
                <h1 className="heading-1">
                  <span className="count">58</span>+
                </h1>
                <h4>Product List</h4>
              </div>
              <div className="col-lg-1-5 col-md-6 text-center">
                <h1 className="heading-1">
                  <span className="count">24</span>+
                </h1>
                <h4>Team Members</h4>
              </div>
              <div className="col-lg-1-5 text-center d-none d-lg-block">
                <h1 className="heading-1">
                  <span className="count">260</span>+
                </h1>
                <h4>Products Sale</h4>
              </div>
            </div>
          </section>
          <div className="container">
            <div className="row">
              <div className="col-xl-10 col-lg-12 m-auto">
                <section className="mb-50">
                  <h2 className="title style-3 mb-40 text-center">Our Team</h2>
                  <div className="row">
                    <div className="col-lg-4 mb-lg-0 mb-md-5 mb-sm-5">
                      {/* <h6 className="mb-5 text-brand">Our Team</h6> */}
                      <h1 className="mb-30">Meet Our Expert Team</h1>
                      <p className="mb-30">
                        ADEEBA ADEEL
                        <br />
                        SOFTWARE ENGINEER
                        <br />
                      </p>
                      <p className="mb-30">
                        HUZAIFA HARIS
                        <br />
                        SOFTWARE ENGINEER
                        <br />
                      </p>
                      <p className="mb-30">
                        NAWAZ RASOOL
                        <br />
                        SOFTWARE ENGINEER
                        <br />
                      </p>
                      <a className="btn">View All Members</a>
                    </div>
                    <div className="col-lg-8">
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <div className="team-card">
                            <img
                              src="../../assets/imgs/page/about-6.png"
                              alt=""
                            />
                            <div className="content text-center">
                              <h4 className="mb-5">Adeeba Adeel</h4>
                              {/* <span>CEO & Founder</span> */}
                              <div className="social-network mt-20">
                                <a>
                                  <img
                                    src="../../assets/imgs/theme/icons/icon-facebook-brand.png"
                                    alt=""
                                  />
                                </a>
                                <a>
                                  <img
                                    src="../../assets/imgs/theme/icons/icon-twitter-brand.png"
                                    alt=""
                                  />
                                </a>
                                <a>
                                  <img
                                    src="../../assets/imgs/theme/icons/icon-instagram-brand.png"
                                    alt=""
                                  />
                                </a>
                                <a>
                                  <img
                                    src="../../assets/imgs/theme/icons/icon-youtube-brand.png"
                                    alt=""
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="team-card">
                            <img
                              src="../../assets/imgs/page/about-8.png"
                              alt=""
                            />
                            <div className="content text-center">
                              <h4 className="mb-5">Huzaifa And Nawaz</h4>
                              {/* <span>Co-Founder</span> */}
                              <div className="social-network mt-20">
                                <a>
                                  <img
                                    src="../../assets/imgs/theme/icons/icon-facebook-brand.png"
                                    alt=""
                                  />
                                </a>
                                <a>
                                  <img
                                    src="../../assets/imgs/theme/icons/icon-twitter-brand.png"
                                    alt=""
                                  />
                                </a>
                                <a>
                                  <img
                                    src="../../assets/imgs/theme/icons/icon-instagram-brand.png"
                                    alt=""
                                  />
                                </a>
                                <a>
                                  <img
                                    src="../../assets/imgs/theme/icons/icon-youtube-brand.png"
                                    alt=""
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
